/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ChatIcon from '@material-ui/icons/Chat';
import { useTranslation } from 'react-i18next';

import SummaryCard from '../../common/SummaryCard/SummaryCard';
import { actionTypes } from '../../common/SummaryCard/CardContext';

const useStyles = makeStyles(() => {
  return {
    cardMaxWidth: {
      maxWidth: 'unset',
    },
  };
});

export default function DeclarationsCard({ declarationEntries, isSummary, readOnly, cardTitle }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <SummaryCard
      Icon={ChatIcon}
      cardTitle={cardTitle ?? t('declarations')}
      subheader=""
      entries={declarationEntries}
      sectionName="submission_declaration"
      actionType={isSummary ? null : actionTypes.SUMMARY}
      isSummary={isSummary}
      readOnly={readOnly}
      className={classes}
    />
  );
}
